import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import MesaCard from './MesaCard';
import MesasLibres from './MesasLibres';
import PlanoSalon from '../PlanoSalon/PlanoSalon';

import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap';

const DashboardMozo = () => {
  const [mesasAsignadas, setMesasAsignadas] = useState([]);
  const [activeTab, setActiveTab] = useState('asignadas');
  const [refetchLibres, setRefetchLibres] = useState(false);

  const mozo = JSON.parse(localStorage.getItem('user'));
  const business = JSON.parse(localStorage.getItem('business'));

  const traerMesasAsignadas = async () => {
    try {
      const res = await api.get(`/mesas?mozo_id=${mozo.id}`);
      setMesasAsignadas(res.data);
    } catch (error) {
      console.error('Error al obtener las mesas asignadas:', error);
    }
  };

  useEffect(() => {
    if (activeTab === 'asignadas') traerMesasAsignadas();
    if (activeTab === 'libres') setRefetchLibres(prev => !prev);
  }, [activeTab]);

  const handleRefresh = () => traerMesasAsignadas();

  return (
    <Container fluid className="p-4">
{/*       <h2 className="mb-4">Mis Mesas</h2> */}

      <Tabs activeKey={activeTab} onSelect={setActiveTab} className="mb-3" fill>
        <Tab eventKey="asignadas" title="🧑‍🍳 Asignadas">
          <Row>
            {mesasAsignadas.length === 0 ? (
              <Col>
                <p>No tenés mesas asignadas actualmente.</p>
              </Col>
            ) : (
              mesasAsignadas.map(mesa => (
                <Col key={mesa.id} xs={12} sm={6} md={4} lg={3} className="mb-4">
                  <MesaCard mesa={mesa} onRefresh={handleRefresh} />
                </Col>
              ))
            )}
          </Row>
        </Tab>

        <Tab eventKey="libres" title="🟢 Libres">
          <MesasLibres
            businessId={business.id}
            onRefresh={handleRefresh}
            refetchTrigger={refetchLibres}
          />
        </Tab>
      <Tab eventKey="plano" title="📐 Plano">
    {activeTab === 'plano' && (
      <PlanoSalon
        editable={false}
        mostrarAccionesMozo={true}
        onRefresh={handleRefresh}
      />
    )}
  </Tab>
      </Tabs>
    </Container>
  );
};

export default DashboardMozo;
